export default "__VITE_ASSET__ZUSMX4Sa__"